import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback } from 'react';
import { Icon } from '@iconify/react';
import { NavLink as RouterLink, matchPath, useLocation } from 'react-router-dom';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill';
// material
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, List, Collapse, ListItemText, ListItemIcon, ListSubheader, ListItemButton } from '@mui/material';
import { analytics, firestore } from '../contexts/FirebaseContext';
import { useSelector } from 'react-redux';
import useAuthUsers from '../hooks/useAuthUsers';
import { sidebarConfigExtra } from '../layouts/dashboard/SidebarConfig';
import { analyticsEvents } from '../constants/analyticsEvents';

// ----------------------------------------------------------------------

const ListSubheaderStyle = styled((props) => <ListSubheader disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(5),
    color: theme.palette.text.primary
  })
);

const ListItemStyle = styled(ListItemButton)(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: 'relative',
  textTransform: 'capitalize',
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(2.5),
  color: theme.palette.text.secondary,
  '&:before': {
    top: 0,
    right: 0,
    width: 3,
    bottom: 0,
    content: "''",
    display: 'none',
    position: 'absolute',
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    backgroundColor: theme.palette.primary.main
  }
}));

const ListItemIconStyle = styled(ListItemIcon)({
  width: 22,
  height: 22,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

// ----------------------------------------------------------------------

NavItem.propTypes = {
  isShow: PropTypes.bool,
  item: PropTypes.object
};

function NavItem({ item, isShow }) {
  const theme = useTheme();
  const { pathname } = useLocation();
  const { title, path, icon, info, children } = item;
  const roles = item.roles || [];
  const isActiveRoot = path ? !!matchPath({ path, end: false }, pathname) : false;
  const { currentUser } = useAuthUsers();
  const userTypeId = currentUser.role;

  const [open, setOpen] = useState(isActiveRoot);

  const handleOpen = () => {
    setOpen(!open);
  };

  const activeRootStyle = {
    color: 'primary.main',
    fontWeight: 'fontWeightMedium',
    bgcolor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    '&:before': { display: 'block' }
  };

  const activeSubStyle = {
    color: 'text.primary',
    fontWeight: 'fontWeightMedium'
  };

  if (children && (roles.includes(userTypeId) || item.allow)) {
    return (
      <>
        <ListItemStyle
          onClick={() => {
            handleOpen();
            analytics.logEvent(analyticsEvents.view_item_list, {
              item: title
            });
          }}
          sx={{
            ...(isActiveRoot && activeRootStyle)
          }}
        >
          <ListItemIconStyle>{icon && icon}</ListItemIconStyle>

          {isShow && (
            <>
              <ListItemText disableTypography primary={title} />
              {info && info}
              <Box
                component={Icon}
                icon={open ? arrowIosDownwardFill : arrowIosForwardFill}
                sx={{ width: 16, height: 16, ml: 1 }}
              />
            </>
          )}
        </ListItemStyle>

        {isShow && (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {children.map((item) => {
                const { title, path } = item;
                const isActiveSub = path ? !!matchPath({ path, end: false }, pathname) : false;

                console.log('este es el ', title);

                return (
                  <ListItemStyle
                    key={title}
                    component={RouterLink}
                    to={path}
                    sx={{
                      ...(isActiveSub && activeSubStyle)
                    }}
                  >
                    <ListItemIconStyle>
                      <Box
                        component="span"
                        sx={{
                          width: 4,
                          height: 4,
                          display: 'flex',
                          borderRadius: '50%',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: 'text.disabled',
                          transition: (theme) => theme.transitions.create('transform'),
                          ...(isActiveSub && {
                            transform: 'scale(2)',
                            bgcolor: 'primary.main'
                          })
                        }}
                      />
                    </ListItemIconStyle>
                    <ListItemText disableTypography primary={title} />
                  </ListItemStyle>
                );
              })}
            </List>
          </Collapse>
        )}
      </>
    );
  }

  if (roles.includes(userTypeId) || item.allow) {
    return (
      <ListItemStyle
        component={RouterLink}
        to={path}
        sx={{
          ...(isActiveRoot && activeRootStyle)
        }}
      >
        <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
        {isShow && (
          <>
            <ListItemText disableTypography primary={title} />
            {/* <p>Holaaaaaaaaaaa</p> */}
            {info && info}
          </>
        )}
      </ListItemStyle>
    );
  }
  return <></>;
}

NavSection.propTypes = {
  isShow: PropTypes.bool,
  navConfig: PropTypes.array
};

export default function NavSection({ navConfig, isShow = true, ...other }) {
  const [allowedSection, setAllowedSection] = useState([]);
  const [allowedViewsRol, setAllowedViewsRol] = useState([]);
  const { actualRol } = useSelector((state) => state.dagpacketRoles);
  const { currentUser } = useAuthUsers();

  // console.log('este es el rol', userTypeId);
  // console.log('lista de views', allowedViewsRol);

  const getRoles = useCallback(async () => {
    const allowedSectionArr = [];
    const allowedViewsArr = [];

    actualRol?.sectionViews?.map((us) => {
      if (us?.showSectionView) {
        allowedSectionArr.push(us.id);
      }

      us.allowedViews.map((vi) => {
        if (vi.allowed === true) {
          allowedViewsArr.push(vi.id);
        }
        return false;
      });
      return false;
    });

    setAllowedSection(allowedSectionArr);
    setAllowedViewsRol(allowedViewsArr);
  }, [actualRol]);

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  return (
    <Box {...other}>
      {navConfig.map((list, i) => {
        const { subheader, idSection, items, roles, allow } = list;
        // const rolesAr = roles || [];

        // console.log('el subheader', subheader);
        // console.log('sections', allowedSection);

        return (
          <React.Fragment key={i}>
            {allowedSection.includes(idSection) && (
              <List key={subheader} disablePadding>
                <ListSubheaderStyle>{subheader}</ListSubheaderStyle>
                {items.map((item) => {
                  if (allowedViewsRol.includes(item.id)) {
                    return <NavItem key={item.id} item={item} isShow={isShow} />;
                  }
                  return null;
                })}
              </List>
            )}
          </React.Fragment>
        );
      })}

      {/* {sidebarConfigExtra.map((list, i) => {
        const { subheader, items, etiquetaPermitida, allow } = list;

        return (
          <React.Fragment key={list.subheader + i}>
            {currentUser?.etiquetas?.includes(etiquetaPermitida) && (
              <List key={subheader} disablePadding>
                <ListSubheaderStyle>{subheader}</ListSubheaderStyle>
                {items.map((item) => (
                  <NavItem key={item.title} item={item} isShow={isShow} />
                ))}
              </List>
            )}
          </React.Fragment>
        );
      })} */}

      {/* {navConfig.map((list) => {
        const { subheader, items, roles, allow } = list;
        const rolesAr = roles || [];

        if (rolesAr.includes(userTypeId) || allow) {
          return (
            <List key={subheader} disablePadding>
              {isShow && <ListSubheaderStyle>{subheader}</ListSubheaderStyle>}
              {items.map((item) => (
                <NavItem key={item.title} item={item} isShow={isShow} />
              ))}
            </List>
          );
        }
        return <></>;
      })} */}
    </Box>
  );
}
